import styled from 'styled-components';

export const SummaryContainer = styled.div`
  margin-top: 24px;
  padding-bottom: 20px;
`;

export const SummaryBox = styled.div`
  background: #ededed;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  position: relative;
  padding-bottom: 30px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    background-image:
      radial-gradient(circle at 10px 10px, white 10px, #ededed 10px);
    background-size: 20px 20px;
    background-position: 0 0;
    background-repeat: repeat-x;
  }
`;

export const SummaryItem = styled.div`
  background: white;
  padding: 12px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #4b5563;
`;

export const Divider = styled.div`
  border-top: 2px solid #ccc;
  margin: 16px 0;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: #000;
`;